// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__UDzoH"};